import gql from 'graphql-tag';

const flatRatesFromBatchesQuery = gql`
  query flatRatesFromBatches($flatRateOfferBatchId: Int!) {
    flatRates(flatRateOfferBatchId: $flatRateOfferBatchId) {
      id
      dealerNo
    }
  }
`;

export default flatRatesFromBatchesQuery;
